import React from 'react';
export function Footer() {
  return <footer className="bg-white border-t border-hairline text-ink-light py-12 text-center font-sans text-sm pb-24 md:pb-12" data-id="element-158">
      <div className="max-w-3xl mx-auto px-6 space-y-4" data-id="element-159">
        <p className="font-sans text-lg text-ink font-bold" data-id="element-160">
          Protocolo Calma 3 Minutos
        </p>
        <p data-id="element-161">© {new Date().getFullYear()} Todos los derechos reservados.</p>
        <div className="flex justify-center gap-6 pt-4 font-medium" data-id="element-162">
          <a href="#" className="hover:text-coral transition-colors" data-id="element-163">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-coral transition-colors" data-id="element-164">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-coral transition-colors" data-id="element-165">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}